/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function ArrowBack(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                version='1.1'
                viewBox='0 0 35 27'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>back arrow</title>
                <desc>Created with Sketch.</desc>
                <g
                    fill='none'
                    fillRule='evenodd'
                    id='2019-Admin-enhancements'
                    stroke='none'
                    strokeWidth='1'
                >
                    <g
                        fill={iconColor || '#FFFFFF'}
                        id='BankOps:-Adj-Screen'
                        transform='translate(-145.000000, -50.000000)'
                    >
                        <polygon
                            id='back-arrow'
                            points='180 61.2660543 152.429638 61.2660543 160.838246 52.7683302 158.099559 50 145 63.2432432 158.099559 76.4864865 160.838246 73.7181563 152.429638 65.2204322 180 65.2204322'
                        />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}